<template>
  <VInput
    id="cash-receipt-input"
    ref="identity"
    placeholder="사업자 번호를 입력하세요"
    :value="number"
    :onChanged="onChangeInput"
    :maxlength="11"
    :onBlur="onBlur"
    :onFocus="onFocus"
    :onFirstCheck="onFirstCheck"
    :isValidate="validate"
    errorMessage="올바른번호를 입력하세요"
    pattern="\d*"
  />
</template>

<script>
import VInput from '@/presentationals/v2/components/layouts/atoms/VInput'
import { phoneValidPattern } from '../../../../../../../../models/PreOrder/OrderRequest'

export default {
  name: 'BusinessState',
  components: {
    VInput
  },
  props: {
    number: {
      type: [String, Number],
      required: true
    },
    onChanged: {
      type: Function,
      required: true
    }
  },
  computed: {
    validate() {
      if (this.number.length === 0 && this.firstState === false) {
        this.firstState = true
        return true
      }

      return this.isValidate && !!this.number.match(/^[0-9+]*$/)
    }
  },
  methods: {
    onChangeInput(e) {
      e.currentTarget.value = e.currentTarget.value.replace(/ /gi, '')

      this.isValidate = e.currentTarget.value.length >= 10

      if (phoneValidPattern.test(e.currentTarget.value)) {
        const tempEvent = {
          ...e,
          currentTarget: {
            ...e.currentTarget,
            value: e.currentTarget.value.replace(phoneValidPattern, '')
          }
        }

        this.onChanged(tempEvent)
        return
      }

      this.onChanged(e)
    },

    onFocus(e) {
      e.srcElement.value = e.currentTarget.value.replace(/ /gi, '')
      if (this.number.length < 10) {
        this.isValidate = false
      }
    },

    onBlur(e) {
      const text = e.srcElement.value

      if (text.length === 11) {
        e.srcElement.value = `${text.slice(0, 3)} ${text.slice(3, 7)} ${text.slice(7)}`
      } else if (text.length === 10) {
        e.srcElement.value = `${text.slice(0, 3)} ${text.slice(3, 6)} ${text.slice(6)}`
      } else {
        this.isValidate = false
      }
    },

    onFirstCheck() {
      const text = this.$refs.identity.$el.firstChild.value

      if (text.length < 10) {
        this.isValidate = false
        return
      }

      this.$nextTick(() => {
        if (text.length === 11) {
          this.$refs.identity.$el.firstChild.value = `${text.slice(0, 3)} ${text.slice(
            3,
            7
          )} ${text.slice(7)}`
        } else if (text.length === 10) {
          this.$refs.identity.$el.firstChild.value = `${text.slice(0, 3)} ${text.slice(
            3,
            6
          )} ${text.slice(6)}`
        }
      })

      this.isValidate = true
    }
  },
  data() {
    return {
      isValidate: false,
      firstState: false
    }
  }
}
</script>
